const PREFIXES_WITHOUT_LIVE_MODE = ['cmpt_', 'org_', 'play_', 'shrd_', 'wksp_'];

export default function isModelessId(id: string): boolean {
  const last = id.split('/').pop();

  if (!last) {
    throw new Error('The id provided is invalid');
  }

  return PREFIXES_WITHOUT_LIVE_MODE.some((prefix) => last.startsWith(prefix));
}
